import React from 'react';
import { Form, Modal, Segment, Button } from 'semantic-ui-react';
import { BaseURLDev, headers } from '../../../../../../_utils/config';
import swal from 'sweetalert';

export default class ModalEdit extends React.Component {
   
   constructor(props){
      super(props);
      this.state = {
         data:{
            nama_bank : props.data_edit.nama_bank,
            alamat_bank : props.data_edit.alamat_bank,
            contact_bank : props.data_edit.contact_bank,
            public_id: props.data_edit.public_id,
            nama: props.data_edit.nama,
            kode: props.data_edit.kode,
            jabatan: props.data_edit.jabatan,
            alamat: props.data_edit.alamat,
            contact: props.data_edit.contact,
         },
         
         request:true,
         loading:false
      }

      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      
   }

   onSubmit(e){
      const { nama, jabatan, alamat, nama_bank, alamat_bank, contact_bank } = this.state.data;      
      e.preventDefault();
      if((nama===null || nama==="")){
         swal("","Nama Pegawai harus diisi terlebih dahulu", "error");
         return false;
      }else if(jabatan===null || jabatan===""){
         swal("","Jabatan Pegawai harus diisi terlebih dahulu", "error");
         return false;
      }else if(alamat===null || alamat===""){
         swal("","Alamat Pegawai harus diisi terlebih dahulu", "error");
         return false;
      }else if(nama_bank===null || nama_bank===""){
         swal("","Nama Bank harus diisi terlebih dahulu", "error");
         return false;
      }else if(alamat_bank===null || alamat_bank===""){
         swal("","Alamat Bank harus diisi terlebih dahulu", "error");
         return false;
      }else{
         this.setState({loading:true});
         fetch(`${BaseURLDev}/user/bank/${this.state.data.public_id}`,{
            method: 'PUT',
            body: JSON.stringify(this.state.data),
            headers
         })
         .then(response => {
            if (!response.ok) { 
                  swal("","Update data user Bank gagal", "error");
                  this.setState({loading:false,error:true});
                  return Promise.reject(response.statusText);
               }
            else{
               this.setState({loading:false});   
               swal("","Update data user Bank selesai", "success");
            }
         })
         .catch(err =>{
            swal("","Silahkan check koneksi internet Anda\n atau sedang terjadi gangguan di server", "error");
            this.setState({requests:false})
            return false;
         })
      }
   }

   onChange = (e) => this.setState({data:{...this.state.data, [e.target.name]:e.target.value}})      

   render() {

      const {nama,kode,jabatan,alamat,contact,nama_bank,alamat_bank,contact_bank} = this.state.data;
      const {error,loading} = this.state;
      
      return (
      <div>
         <Modal trigger={<Button>Show Modal</Button>}
            open={this.props.open}
            onClose={this.props.onClose}
            closeOnEscape={false}
            closeOnRootNodeClick={false}
            size="small"
         >
            <Modal.Header>
               Edit user Bank username : {this.props.data_edit.user.username}
            </Modal.Header>
            
            <Modal.Content>
               <Segment>
                  <Form onSubmit={this.onSubmit} error={error} loading={loading}>
                     <Form.Input value={kode} onChange={this.onChange} name="kode" title="NIP/Kode Pegawai" placeholder="NIP/Kode Pegawai"/>
                     <Form.Input value={nama} onChange={this.onChange} name="nama" title="Nama pegawai" placeholder='Nama pegawai' />               
                     <Form.Input value={jabatan} onChange={this.onChange} name="jabatan" title="Jabatan pegawai" placeholder='Jabatan pegawai' />               
                     <Form.Input value={contact} onChange={this.onChange} name="contact" title="Nomor contact" placeholder='Nomor contact' />               
                     <Form.TextArea value={alamat} onChange={this.onChange} placeholder='Alamat pegawai' title="alamat" name="alamat" />
                     <Form.Input value={nama_bank} onChange={this.onChange} name="nama_bank" title="Nama Bank/Unit/Cabang/Capem" placeholder='Nama Bank/Unit/Cabang/Capem' />                              
                     <Form.Input value={contact_bank} onChange={this.onChange} name="contact_bank" title="Nomor contact bank" placeholder='Nomor contact bank' />               
                     <Form.TextArea value={alamat_bank} onChange={this.onChange} title="Alamat bank tempat bertugas" placeholder='Alamat bank tempat bertugas' name="alamat_bank" />               
                     <Form.Button positive>Perbaharui</Form.Button>
                  </Form>
               </Segment>
            </Modal.Content>
            <Modal.Actions>
               <Button negative onClick={this.props.onClose}>Tutup</Button>                        
            </Modal.Actions>
         </Modal>
      </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_user/_userbank/ModalEdit.js